import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";

import translate from "../../../../services/Translate";
import { CurrentFilters, SelectCustomFilterProps } from "./CustomFilterDropdown.d";

const CustomFilterDropdown = ({
  closeModal,
  language,
  show,
  onApplyFilter,
  activeCustomFilter,
}: SelectCustomFilterProps) => {
  const [customFilters, setCustomFilters] = useState<Record<string, CurrentFilters>>({});

  useEffect(() => {
    if (show) {
      try {
        const savedFilters = JSON.parse(localStorage.getItem("nexus-custom-filters-corrections") || "{}");
        setCustomFilters(savedFilters);
      } catch (error) {
        console.error("An error occurred with custom filters.", error);
        setCustomFilters({});
      }
    }
  }, [show]);

  const _applySelectedFilter = (filterName: string) => {
    if (!filterName || !customFilters[filterName]) return;

    onApplyFilter(customFilters[filterName], filterName);

    closeModal();
  };

  const _deleteFilter = (filterName: string, event: React.MouseEvent) => {
    event.stopPropagation();

    if (
      !window.confirm(
        translate(language, "PAGES.ATTEMPTS.FILTER.SELECT_MODAL.CONFIRM_DELETE").replace("{{FILTER_NAME}}", filterName)
      )
    ) {
      return;
    }

    const updatedFilters = { ...customFilters };
    delete updatedFilters[filterName];

    localStorage.setItem("nexus-custom-filters-corrections", JSON.stringify(updatedFilters));
    setCustomFilters(updatedFilters);

    if (activeCustomFilter === filterName) {
      onApplyFilter(
        {
          statuses: [],
          formats: [],
          languages: [],
          poles: [],
          programs: [],
          flags: [],
        },
        ""
      );
    }
  };

  const filterNames = Object.keys(customFilters);

  if (!show) return null;

  return (
    <Dropdown.Menu show className="dropup">
      <Dropdown.Header>{translate(language, "PAGES.ATTEMPTS.FILTER.SELECT_MODAL.TITLE")}</Dropdown.Header>

      {filterNames.length === 0 ? (
        <Dropdown.ItemText>
          <div className="text-muted">{translate(language, "PAGES.ATTEMPTS.FILTER.SELECT_MODAL.NO_FILTERS")}</div>
        </Dropdown.ItemText>
      ) : (
        filterNames.map((filterName) => {
          const isActive = activeCustomFilter === filterName;

          return (
            <div
              key={filterName}
              className={`s-regular d-flex align-items-center justify-content-between clickable px-3 py-2 ${
                isActive ? "active" : "dropdown-item"
              }`}
              onClick={() => _applySelectedFilter(filterName)}
            >
              <div className="s-regular text-truncate" style={{ maxWidth: 250 }}>
                <span>{filterName}</span>
                {isActive && <span className="dst-icon-check-circle ms-2" />}
              </div>
              <span
                className="dst-icon-trash-01 text-danger ms-3 clickable"
                onClick={(event) => _deleteFilter(filterName, event)}
              />
            </div>
          );
        })
      )}
    </Dropdown.Menu>
  );
};

export default CustomFilterDropdown;
